import { render, staticRenderFns } from "./InvestorProjectsComponent.vue?vue&type=template&id=67ff1460&scoped=true"
import script from "./InvestorProjectsComponent.vue?vue&type=script&lang=js"
export * from "./InvestorProjectsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff1460",
  null
  
)

export default component.exports